import { getCookie, setCookie, removeCookie } from './cookies';
import {
  getItemFromStorage,
  setItemToStorage,
  removeItemFromStorage,
} from './localStorage';

const isMobileApp = () =>
  typeof window !== 'undefined' &&
  (
    window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }
  ).Capacitor?.isNativePlatform?.() === true;

const getToken = () => {
  if (isMobileApp()) {
    return getItemFromStorage('token');
  }
  return getCookie('token') || getItemFromStorage('token');
};

const setToken = (value?: string) => {
  if (isMobileApp()) {
    setItemToStorage('token', value || '');
  } else {
    setCookie('token', value || '');
  }
};

const getIsSuperUser = () => getItemFromStorage('superuser') === 'true';

const setIsSuperUser = (value = false) => {
  setItemToStorage('superuser', value ? 'true' : 'false');
};

const getLocale = () => getItemFromStorage('locale');

const setLocale = (value: string) => {
  setItemToStorage('locale', value);
};

const getSessionId = () => {
  if (isMobileApp()) {
    return getItemFromStorage('sessionId');
  }
  return getCookie('sessionId');
};

const setSessionId = (value: string) => {
  if (isMobileApp()) {
    setItemToStorage('sessionId', value);
  } else {
    setCookie('sessionId', value);
  }
};

const setCookieAuthenticated = () => {
  setItemToStorage('authenticatedFromCookie', 'true');
};

const reset = () => {
  // Supprime les tokens du localStorage
  removeItemFromStorage('token');
  removeItemFromStorage('superuser');
  removeItemFromStorage('authenticatedFromCookie');
  removeItemFromStorage('sessionId');

  // Supprime les cookies si on est sur web
  if (!isMobileApp()) {
    removeCookie('token');
    removeCookie('sessionId');
    // Supprime aussi le cookie de statut
    document.cookie =
      'snc-status=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.scorenco.com; path=/';
  }
};

export const userSession = {
  getToken,
  setToken,
  getIsSuperUser,
  setIsSuperUser,
  getLocale,
  setLocale,
  reset,
  getSessionId,
  setSessionId,
  setCookieAuthenticated,
};
